import { TweenLite } from 'gsap/all';
import WrongIcon from '../icons/RedXSolidIcon.vue';
import CorrectIcon from '../icons/SuccessCheckSolidIcon.vue';
import Vue from 'vue';
export default Vue.extend({
    props: {
        options: {
            type: Array,
            required: true
        },
        sentenceIndex: {
            type: Number,
            required: true
        },
        dropdownIndex: {
            type: Number,
            required: true
        },
        onItemSelect: {
            type: Function,
            required: true
        },
        enabled: {
            type: Boolean,
            default: true
        },
        isCorrect: {
            type: Boolean,
            default: false
        },
        numOfAttempts: {
            type: Number,
            default: 0
        }
    },
    components: {
        WrongIcon,
        CorrectIcon
    },
    data() {
        return {
            collapsed: true,
            selection: null,
            showIcon: false
        };
    },
    watch: {
        numOfAttempts() {
            this.showIcon = true;
            TweenLite.delayedCall(1.5, () => {
                if (this.selection && !this.selection.correct) {
                    this.selection = null;
                }
                this.showIcon = false;
            });
        }
    },
    methods: {
        handleFocusOut() {
            if (!this.collapsed) {
                this.collapsed = true;
            }
        },
        onDropDownClick() {
            if (this.isCorrect)
                return;
            this.collapsed = !this.collapsed;
        },
        handleSelection(option) {
            this.onItemSelect({
                sentenceIndex: this.sentenceIndex,
                dropdownIndex: this.dropdownIndex,
                option
            });
            this.selection = option;
            this.collapsed = true;
        }
    }
});
